import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vidboardAvatars: [],
  userAvatars: [],
  proAvatars: [],
  backgroundAvatars: [],
};

const avatarsSlice = createSlice({
  name: "avatars",
  initialState,
  reducers: {
    // Reducer to set vidboard avatars
    setVidboardAvatars(state, action) {
      state.vidboardAvatars = action.payload;
    },
    // Reducer to set user avatars
    setUserAvatars(state, action) {
      state.userAvatars = action.payload;
    },
    setProAvatars(state, action) {
      state.proAvatars = action.payload;
    },
    setBackGroundAvatars(state, action) {
      state.backgroundAvatars = action.payload;
    },
  },
});

export const {
  setBackGroundAvatars,
  setVidboardAvatars,
  setUserAvatars,
  setProAvatars,
} = avatarsSlice.actions;
export default avatarsSlice.reducer;
